module.exports = __webpack_public_path__ + "img/targets.aaab6d36.png";